import { Box, Heading, UnorderedList } from '@chakra-ui/react'
import colors from '../../../config/theme/colors'
import { GroupsProps } from './types'

export default function Groups({ title, children }: GroupsProps) {
    return (
        <Box borderRadius="md" bg="white" p="3" borderWidth="1px" w="full">
            <Heading
                size="sm"
                color={colors.white}
                py="1"
                px="3"
                borderRadius="md"
                mb={3}
                bg={colors['alo-blue']}
            >
                {title}
            </Heading>
            <UnorderedList fontSize="sm" ml={5} spacing={1}>
                {children}
            </UnorderedList>
        </Box>
    )
}
